import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useState, useEffect } from "react";
import configuration from "../../config";
import { toast } from "react-toastify";
import labels from "../../constants/FestivalArea";
import _ from "underscore"

// For Add festival-area
function Add({ history }) {
  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];
  const [countryOpt, setCurrencyOpt] = useState([]);
  const [stateOpt, setStateOpt] = useState([]);
  const [cityOpt, setCityOpt] = useState([]);
  const fieldArr = [
    {
      id: 0,
      title: "Country",
      name: "country_id",
      type: "Dropdown",
      options: countryOpt,
    },
    {
      id: 1,
      title: "State",
      name: "state_id",
      type: "Dropdown",
      options: stateOpt,
    },
    {
      id: 1,
      title: "City",
      name: "city_id",
      type: "Dropdown",
      options: cityOpt,
    },
    { id: 2, title: "Title", name: "name", type: "TextInput" },
    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
    {
      id: 4,
      title: "Polygon",
      name: "polygon",
      type: "GoogleMap",
      is_full_screen: true
    },
  ];

  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({
    name: "",
    country_id: "",
    state_id: "",
    status: "",
  });


  function handleValidation() {
    let flag = true;
    let error = {}
    if (!fields.name) {
      error['name'] = "Please enter festival area title"
      flag = false
    }

    if (!fields.country_id) {
      error['country_id'] = "Please select country"
      flag = false
    }

    if (!fields.state_id) {
      error['state_id'] = "Please select state"
      flag = false
    }
    if (!fields.city_id) {
      error['city_id'] = "Please select city"
      flag = false
    }
    if (!fields.status) {
      error['status'] = "Please select status"
      flag = false
    }
    // if (!fields.polygon) {
    //   error['polygon'] = "Please select polygon"
    //   flag = false
    // }
    setErrors({ ...error })
    return flag;
  }

  function getCountryDatas() {
    configuration
      .getAPI({ url: "country/list", params: {} })
      .then((data) => {
        if (data.status === 200) {
          if (data.payload.length > 0) {
            data.payload.forEach((element) => {
              element.title = element.name;
              element.value = element.country_id;
              element.id = element.country_id;

              return element;
            });
          }
          setCurrencyOpt(data.payload);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }

  function getStateDatas(params) {
    configuration
      .getAPI({ url: "state/list", params })
      .then((data) => {
        if (data.status === 200) {
          if (data.payload.length > 0) {
            data.payload.forEach((element) => {
              element.title = element.name;
              element.value = element.state_id;
              element.id = element.state_id;

              return element;
            });
          }
          setStateOpt(data.payload);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }

  function getCityDatas(params) {
    configuration
      .getAPI({ url: "city/list", params })
      .then((data) => {
        if (data.status === 200) {
          if (data.payload.length > 0) {
            data.payload.forEach((element) => {
              element.title = element.name;
              element.value = element.city_id;
              element.id = element.city_id;

              return element;
            });
          }
          setCityOpt(data.payload);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }

  useEffect(() => {
    getCountryDatas();
    // getStateDatas();
  }, []);

  function handleChange(field, e) {
    if (field === "polygon" || field === 'is_rental') {
      setFields({ ...fields, [field]: e });
      return
    }

    if (field === "country_id" && !e.target.value) {
      setStateOpt([]);
      setCityOpt([]);
    }
    if (field === "state_id" && !e.target.value) {
      setCityOpt([]);
    }
    if (field === "country_id" && e.target.value) {
      getStateDatas({ country_id: e.target.value });
      setFields({ ...fields, ["state_id"]: '', ["city_id"]: '', [field]: e.target.value });
    } else if (field === "state_id" && e.target.value) {
      getCityDatas({ state_id: e.target.value });
      setFields({ ...fields, ["state_id"]: '', ["city_id"]: '', [field]: e.target.value });
    } else {
      setFields({ ...fields, [field]: e.target.value });
    }
  }
  // function handleChange(field, e) {
  //   setFields({ ...fields, [field]: e.target.value });
  // }

  const handleSubmit = () => {
    if (handleValidation()) {

      configuration
        .postAPI({ url: "festival-area/create", params: fields })
        .then((data) => {
          if (data.status === 200) {
            history.push("/festival-area");
            // setData(data.payload)
          } else if (data.error) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          return toast.error(error.message);
        });
    }
  };

  return (
    <>
      <Breadcrumb module={labels.addFestivalArea} />
      <AddEditSection
        title="Add Festival Area"
        path="/festival-area"
        fields={fieldArr}
        fieldError={errors}

        fieldValue={fields}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
